import React, { useState, useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom';
import { Client } from '../pages/Client';
import { mockFetchUser } from '../pages/FetchUpdateUserData';
import { useSelector } from 'react-redux';
import LoadingElement from '../components/features/LoadingElement';

export const ClientInfoRoute = () => {
    const { client_id } = useParams();
    const [clientData, setClientData] = useState(null);
    const userInfo = useSelector((state) => state.user);
    const [userNotFound, setUserNotFound] = useState(false);

    useEffect(() => {
        if (userInfo.type === 1) {
            mockFetchUser(client_id).then((data) => {
                if (data) {
                    setClientData(data);
                    console.log(data, "data");
                } else {
                    setUserNotFound(true);
                }
            }).catch((error) => {
                console.error("Error fetching user data:", error);
            });
            
        } else {
            setUserNotFound(true);
        }
    }, [client_id, userInfo.type]);

    if (userNotFound) {
        return <Navigate to="/" />
    }

    if (clientData === null) {
        return <LoadingElement mini={false}/>;
    }

    return (
        <Client clientData={clientData} client_id={client_id} />
    );
}
